import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import queryString from 'query-string';
import { getApplication, setCurrentForm } from "../../redux/actions";
import { getUrlWithStepNumber } from "../../utils/NavigationHelper";

const ResumeApplication = props => {
    const dispatch = useDispatch();

    let applicationId = props.match.params.id;

    useEffect(() => {
        if (applicationId && !isNaN(applicationId)) {
            dispatch(getApplication(applicationId, (response) => {
                console.log('response', response);
                if (response && response.data) {
                    if (response.data.licenceType === 'Tattooist') {
                        dispatch(setCurrentForm("tattooist-form", "Tattooist License"));
                        const stepNumber = response.data && response.data.applicationData ? JSON.parse(response.data.applicationData).stepNumber : "";
                        props.history.push(getUrlWithStepNumber(stepNumber));
                    }
                    else {
                        dispatch(setCurrentForm("operator", "Operator Licence"));
                        props.history.push(`/operator/dashboard`);
                    }
                } else {
                    props.history.push(`/tattooist-form`);
                }
            }));
        }
    }, [applicationId]);

    //   useEffect(() => {
    //     if (applicationId) {
    //       dispatch(storePaymentRefrence({ completionReference: qs.completionReference }));
    //       if (form.form === 'operator') {
    //         props.history.push(`/operator/payment-success`);
    //       } else {
    //         props.history.push(`/tattooist-form/payment-success`);
    //       }
    //     }
    //   }, [applicationId]);

    return null;
}
export default withRouter(props => <ResumeApplication {...props} />);
